/**
 * Get element's tabindex. Returns `null` if not set or if value cannot be parsed to a number
 *
 */
export const getTabindex = (element: Element): number | null => {
  const tabIndexValue = element?.getAttribute('tabindex');

  // if it's not set, return null
  if (tabIndexValue === null || tabIndexValue === undefined) return null;

  const parsedTabindex = parseInt(tabIndexValue, 10);

  // if it can't be parsed to a number, return null
  if (Number.isNaN(parsedTabindex)) return null;

  // otherwise, it's a number and we can return it
  return parsedTabindex;
};
